import { InputBaseComponentProps } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'
import {
  CardCvcElementComponent,
  CardExpiryElementComponent,
  CardNumberElementComponent,
} from '@stripe/react-stripe-js'
import { StripeCardCvcElement, StripeCardExpiryElement, StripeCardNumberElement } from '@stripe/stripe-js'
import React, { useImperativeHandle, useRef } from 'react'

export type StripeComponent = CardCvcElementComponent | CardExpiryElementComponent | CardNumberElementComponent

type Props = InputBaseComponentProps & {
  component: StripeComponent
}

type Ref = {
  focus: () => void
}

type StripeElement = StripeCardCvcElement | StripeCardExpiryElement | StripeCardNumberElement

const StripeInput = React.forwardRef<Ref, Props>(({ component: Component, ...props }, ref) => {
  const theme = useTheme()

  const elementRef = useRef<StripeElement>()
  useImperativeHandle(ref, () => ({
    focus: () => elementRef.current?.focus(),
  }))

  return (
    <Component
      onReady={(element: StripeElement) => {
        elementRef.current = element
      }}
      options={{
        style: {
          base: {
            color: theme.palette.text.primary,
            fontSize: `${theme.typography.fontSize}px`,
            fontFamily: theme.typography.fontFamily,
            '::placeholder': {
              color: alpha(theme.palette.text.primary, 0.42),
            },
          },
          invalid: {
            color: theme.palette.text.primary,
          },
        },
      }}
      {...props}
    />
  )
})

export default StripeInput
